import { getMediaAssetsMetadataForModel, getModelsWithMediaAssetsMetadata } from './media-assets.decorator';
import { isPlainObject } from '@core/shared/utils';
import { MEDIA_PROPS_ACCESSOR } from './constants';
import { MediaAssetErrorCode } from './media-asset-error-code.enum';
import { MediaAssetProvidersBaseService } from '../providers';
export class MediaAssetsHelper {
  static findModelsWithMediaAssetsMetadata() {
    return getModelsWithMediaAssetsMetadata();
  }
  // support for model instances was removed cause there are some situations where the model/entity could be a plain object
  static getConfig(model) {
    if (!model) throw new Error('Data passed to MediaAssetsHelper is falsy. Check before passing it in!');
    if (isPlainObject(model)) {
      throw new Error('MediaAssetsHelper.getConfig received plain object, only classes or instances are supported! ' + JSON.stringify(model));
    }
    const meta = getMediaAssetsMetadataForModel(model);
    if (!meta.length) throw new Error('Model ' + model + ' has no MediaAsset metadata assigned!');
    const config = meta[0].options;
    return config;
  }
  static checkAssetStatusForErrors(asset, providers) {
    if (!asset) {
      throw new Error('Passed asset is null');
    }
    if (!asset.ready) {
      return {
        error: MediaAssetErrorCode.NotReady
      };
    } else if (!asset.directUrl) {
      return {
        error: MediaAssetErrorCode.Invalid
      };
    } else {
      const provider = providers instanceof MediaAssetProvidersBaseService ? providers.getProvider(asset) : providers;
      if (!provider) {
        return {
          error: MediaAssetErrorCode.UnknownProvider
        };
      }
      return {
        error: null
      };
    }
  }
  /**
   * prefer to use getAllAssetMappings with useMetadata=true whenever possible.
   * It will error when modelCtor is no model though, e.g. when working on a plain editor object or similar.
   * For such cases, set useMetadata=false - this will however only work when not using a custom media property name.
   */
  static getAllAssetMappings(model, metadataSrc = true, createIfNotExisting = false) {
    let mediaPropName = MEDIA_PROPS_ACCESSOR;
    if (metadataSrc) {
      const modelCtor = metadataSrc === true ? model?.constructor : metadataSrc;
      const config = this.getConfig(modelCtor);
      mediaPropName = config.targetProperty;
    }
    if (createIfNotExisting && !model[mediaPropName]) model[mediaPropName] = {};
    return model[mediaPropName] || {};
  }
  /**
   * NOTE: getAssetBySlot/getAssetMappingBySlot can only work on Model instances! Passing plain data will fail.
   */
  static getAssetBySlot(model, slotName, metadataSrc = true) {
    const mappings = this.getAssetMappingsBySlot(model, slotName, metadataSrc);
    return mappings[0]?.asset || null;
  }
  static getAssetsBySlot(model, slotName, metadataSrc = true) {
    return this.getAssetMappingsBySlot(model, slotName, metadataSrc).map(mapping => mapping.asset);
  }
  static getAssetMappingsBySlot(model, slotName, metadataSrc = true) {
    if (!model) return [];
    const mappings = this.getAllAssetMappings(model, metadataSrc);
    const slotMappings = mappings[slotName];
    if (!slotMappings) return [];
    if (Array.isArray(slotMappings)) return slotMappings;else return [slotMappings];
  }
  static emptySlot(model, slotName, metadataSrc = true) {
    const mappings = this.getAllAssetMappings(model, metadataSrc, true);
    mappings[slotName] = null;
    return model;
  }
  // NOTE: if the system will ever need to support multi lingual subtitles, this is the central function to rewrite & search for.
  static findAssetSubtitles(asset, lang = null) {
    if (!asset.subtitles || asset.subtitles.length === 0) return null;
    if (!lang) {
      return asset.subtitles[0];
    } else {
      return asset.subtitles.find(entry => entry.lang === lang);
    }
  }
  static convertMediaAssetDetailsToMediaAssetMetadata(data) {
    if (data.completed) {
      return {
        duration: data.duration,
        format: data.format,
        size: data.size
      };
    } else {
      return {
        duration: null,
        format: null,
        size: null
      };
    }
  }
}